"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clearNotification", {
  enumerable: true,
  get: function get() {
    return _clearNotification["default"];
  }
});
Object.defineProperty(exports, "showNotification", {
  enumerable: true,
  get: function get() {
    return _showNotification["default"];
  }
});
var _showNotification = _interopRequireDefault(require("./showNotification"));
var _clearNotification = _interopRequireDefault(require("./clearNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }